import * as ex from "excalibur";
import { TILE_CONFIG, WALL_CONFIG } from "@/config";
import { loadImageResource } from "./resource";
import { TilemapType } from "../../server-2/enums/TilemapType";
import GameApp from "../index";

export class RoomTilemap {
  engine: any;
  gridMatrix: any;
  activePlayerStopped: boolean = false;
  tileMap: ex.TileMap;
  topWall: any = [];
  tile: any = [];
  wallPattern: any;
  topWallPattern: any = [];

  constructor(engine: ex.Engine<any>, gridMatrix: string | any[]) {
    this.engine = engine;
    this.gridMatrix = gridMatrix;

    // Calculate dimensions
    const rows = gridMatrix.length;
    const columns = gridMatrix[0].length;

    const canvasWidth = window.innerWidth;
    const canvasHeight = window.innerHeight;

    const tileMapWidth = columns * TILE_CONFIG.TILE_WIDTH;
    const tileMapHeight = rows * TILE_CONFIG.TILE_HEIGHT;

    // Calculate centered position
    const centerX = (canvasWidth - tileMapWidth) / 2;
    const centerY = (canvasHeight - tileMapHeight) / 2;

    // Update the position of the TileMap
    this.tileMap = new ex.TileMap({
      rows,
      columns,
      tileWidth: TILE_CONFIG.TILE_WIDTH,
      tileHeight: TILE_CONFIG.TILE_HEIGHT,
      pos: ex.vec(centerX, centerY),
    });
  }

  public changeTopWallColor(color: ex.Color) {
    this.topWall.forEach((tile) => {
      tile.color = color;
    });
  }

  public changeTileColor(color: ex.Color) {
    this.tile.forEach((tile) => {
      tile.color = color;
    });
  }

  public async loadWallPattern(pattern: string) {
    try {
      this.wallPattern = await loadImageResource(pattern, "./public/wall/");
    } catch (error) {}
  }

  public changeWallPattern() {
    const sut = new ex.TiledSprite({
      image: this.wallPattern,
      width: 50,
      height: WALL_CONFIG.WALL_HEIGHT_TOP - 20,
      wrapping: {
        x: ex.ImageWrapping.Repeat,
        y: ex.ImageWrapping.Repeat,
      },
    });

    this.topWallPattern.forEach((tile) => {
      tile.addGraphic(sut, {
        offset: ex.vec(0, -52),
      });
    });
  }

  public getFullDimensions(): { width: number; height: number } {
    const width =
      (this.tileMap.columns - 1) * TILE_CONFIG.TILE_WIDTH +
      WALL_CONFIG.THICKNESS;
    const height = this.tileMap.rows * TILE_CONFIG.TILE_HEIGHT;
    return { width, height };
  }

  private async createTiles() {
    let index = 0;

    await this.loadWallPattern("bricks.png");

    for (let row = 0; row < this.gridMatrix.length; row++) {
      for (let col = 0; col < this.gridMatrix[row].length; col++) {
        const tile: any = this.tileMap.getTile(col, row);

        if (
          this.gridMatrix[row][col] === 1 ||
          this.gridMatrix[row][col] === 2
        ) {
          tile.solid = true;
        }

        if (
          [TilemapType.TILE, TilemapType.FURNITURE].includes(
            this.gridMatrix[row][col]
          )
        ) {
          index++;

          const n: any = this.getNeighbours(col, row);
          if (n.top === "wall") {
            if (index === 1) {
              tile.addGraphic(
                new ex.Rectangle({
                  width: WALL_CONFIG.THICKNESS,
                  height:
                    WALL_CONFIG.WALL_HEIGHT_TOP +
                    WALL_CONFIG.BOTTOM_WALL_THICKNESS_FIRST,
                  color: ex.Color.fromHex(WALL_CONFIG.PRIMARY_COLOR),
                }),
                {
                  offset: ex.vec(
                    -WALL_CONFIG.THICKNESS,
                    -TILE_CONFIG.TILE_HEIGHT
                  ),
                }
              );
            }

            // Wall right
            if (index === this.gridMatrix[row].length - 2) {
              tile.addGraphic(
                new ex.Rectangle({
                  width: WALL_CONFIG.THICKNESS,
                  height:
                    WALL_CONFIG.WALL_HEIGHT_TOP +
                    WALL_CONFIG.BOTTOM_WALL_THICKNESS_FIRST,
                  color: ex.Color.fromHex(WALL_CONFIG.PRIMARY_COLOR),
                }),
                {
                  offset: ex.vec(
                    TILE_CONFIG.TILE_WIDTH,
                    -TILE_CONFIG.TILE_HEIGHT
                  ),
                }
              );
            }

            // Store the graphic reference in the topWall array
            const topWallGraphic = new ex.Rectangle({
              width: TILE_CONFIG.TILE_WIDTH,
              height: WALL_CONFIG.WALL_HEIGHT_TOP,
              color: ex.Color.fromHex("a9a3a0"), // Initial color
            });

            tile.addGraphic(topWallGraphic, {
              offset: ex.vec(0, -50),
            });

            // Create a vertical rectangle

            // Add the rectangle to the tile, offsetting it by the calculated X position
            // const colors = [ex.Color.Orange, ex.Color.Brown]; // Color alternation array
            // const numRectangles = 6; // The number of rectangles you want to add

            // // Loop through to add rectangles dynamically
            // for (let i = 0; i < numRectangles; i++) {
            //   const width = TILE_CONFIG.TILE_WIDTH / numRectangles;
            //   const color = colors[i % colors.length]; // Alternate between Orange and Brown
            //   const rectOffsetX = i * width; // Start from 0 and add width for each subsequent rectangle

            //   const rect = new ex.Rectangle({
            //     width, // Use the width here instead of height
            //     height: WALL_CONFIG.WALL_HEIGHT_TOP, // Keep the height constant
            //     color, // Set the current color
            //   });

            //   tile.addGraphic(rect, {
            //     offset: ex.vec(rectOffsetX, -TILE_CONFIG.TILE_HEIGHT), // Apply the rectOffsetX to the X-axis
            //   });
            // }

            // const height = 5;
            // const colors = [ex.Color.Orange, ex.Color.Brown]; // Color alternation array
            // const numRectangles = WALL_CONFIG.WALL_HEIGHT_TOP / height - 1; // The number of rectangles you want to add

            // // Loop through to add rectangles dynamically
            // for (let i = 0; i < numRectangles; i++) {
            //   const color = colors[i % colors.length]; // Alternate between Orange and Brown
            //   const rectHeight = height;
            //   const rectOffsetY = -TILE_CONFIG.TILE_HEIGHT - i * height; // Start at -50 and subtract 10 for each subsequent rectangle

            //   const rect = new ex.Rectangle({
            //     width: TILE_CONFIG.TILE_WIDTH,
            //     height: rectHeight,
            //     color: color, // Set the current color
            //   });

            //   tile.addGraphic(rect, {
            //     offset: ex.vec(0, rectOffsetY),
            //   });
            // }
            this.topWallPattern.push(tile);

            this.topWall.push(topWallGraphic);
            tile.addGraphic(
              new ex.Rectangle({
                width: TILE_CONFIG.TILE_WIDTH,
                height: WALL_CONFIG.BOTTOM_WALL_THICKNESS_FIRST,
                color: ex.Color.fromHex(WALL_CONFIG.PRIMARY_COLOR),
              }),
              {
                offset: ex.vec(
                  0,
                  -WALL_CONFIG.WALL_HEIGHT_TOP - TILE_CONFIG.TILE_HEIGHT
                ),
              }
            );

            tile.addGraphic(
              new ex.Rectangle({
                width: TILE_CONFIG.TILE_WIDTH,
                height: 20,
                color: ex.Color.fromHex("503929"),
              }),
              {
                offset: ex.vec(
                  0,
                  -WALL_CONFIG.WALL_HEIGHT_TOP - TILE_CONFIG.TILE_HEIGHT + 20
                ),
              }
            );
          }

          if (n.left === "wall") {
            tile.addGraphic(
              new ex.Rectangle({
                width: WALL_CONFIG.THICKNESS,
                height: TILE_CONFIG.TILE_HEIGHT,
                color: ex.Color.fromHex(WALL_CONFIG.PRIMARY_COLOR),
              }),
              {
                offset: ex.vec(-WALL_CONFIG.THICKNESS, 0),
              }
            );
          }

          if (n.right === "wall") {
            tile.addGraphic(
              new ex.Rectangle({
                width: WALL_CONFIG.THICKNESS,
                height: TILE_CONFIG.TILE_HEIGHT,
                color: ex.Color.fromHex(WALL_CONFIG.PRIMARY_COLOR),
              }),
              {
                offset: ex.vec(TILE_CONFIG.TILE_WIDTH, 0),
              }
            );
          }

          if (n.bottom === "wall") {
            tile.addGraphic(
              new ex.Rectangle({
                width: TILE_CONFIG.TILE_WIDTH + WALL_CONFIG.THICKNESS * 2,
                height: WALL_CONFIG.BOTTOM_WALL_THICKNESS_FIRST,
                color: ex.Color.fromHex(WALL_CONFIG.PRIMARY_COLOR),
              }),
              {
                offset: ex.vec(
                  -WALL_CONFIG.THICKNESS,
                  WALL_CONFIG.BOTTOM_WALL_THICKNESS_FIRST
                ),
              }
            );

            tile.addGraphic(
              new ex.Rectangle({
                width: TILE_CONFIG.TILE_WIDTH + WALL_CONFIG.THICKNESS * 2,
                height: WALL_CONFIG.BOTTOM_WALL_THICKNESS_SECOND,
                color: ex.Color.fromHex(WALL_CONFIG.SECONDARY_COLOR),
              }),
              {
                offset: ex.vec(
                  -WALL_CONFIG.THICKNESS,
                  WALL_CONFIG.BOTTOM_WALL_THICKNESS_FIRST +
                    WALL_CONFIG.BOTTOM_WALL_THICKNESS_SECOND
                ),
              }
            );
          }

          // Walkable Tile
          tile.solid = false;

          const tileGraphic = new ex.Rectangle({
            width: TILE_CONFIG.TILE_WIDTH,
            height: TILE_CONFIG.TILE_HEIGHT,
            color: ex.Color.LightGray,
            strokeColor: ex.Color.DarkGray,
          });

          tile.addGraphic(tileGraphic);
          this.tile.push(tileGraphic);

          tile.events.on("pointerdown", () => {
            if (this.activePlayerStopped) return;

            GameApp.wsClient.sendMessage(
              JSON.stringify({
                action: "find_path",
                arguments: {
                  target: { x: tile.x, y: tile.y },
                },
              })
            );
          });

          const text = new ex.Text({
            text: `${col}, ${row}`,
            font: new ex.Font({ size: 10 }),
            origin: ex.vec(0.5, 0.5),
          });

          tile.addGraphic(text, {
            offset: ex.vec(15, -15), // Center position
          });
        }
      }
    }

    this.changeWallPattern();
  }

  private getNeighbours(x: number, y: number) {
    const directions = {
      top: { dx: 0, dy: -1 },
      bottom: { dx: 0, dy: 1 },
      left: { dx: -1, dy: 0 },
      right: { dx: 1, dy: 0 },
    };

    let neighbours = {};

    for (const direction in directions) {
      const dx = directions[direction].dx;
      const dy = directions[direction].dy;

      const nx = x + dx;
      const ny = y + dy;

      if (
        nx >= 0 &&
        nx < this.gridMatrix[0].length &&
        ny >= 0 &&
        ny < this.gridMatrix.length
      ) {
        // Check if it's a wall (1) or walkable (0)
        neighbours[direction] =
          this.gridMatrix[ny][nx] === TilemapType.WALL ? "wall" : "tile";
      } else if (
        nx >= 2 &&
        nx < this.gridMatrix[0].length &&
        ny >= 2 &&
        ny < this.gridMatrix.length
      ) {
        neighbours[direction] = "wall";
      }
    }

    return neighbours;
  }

  public addToScene(scene) {
    this.createTiles();
    scene.add(this.tileMap);
  }

  public setSolidTile(pos: ex.Vector) {
    const tile = this.tileMap.getTile(pos.x, pos.y);
    if (!tile) return;

    tile.solid = true;
  }

  public removeSolidTile(pos: ex.Vector) {
    const tile = this.tileMap.getTile(pos.x, pos.y);
    if (!tile) return;
    tile.solid = false;
  }
}
